import { ForwardedRef, RefCallback } from "react";

export const mergeRefs =
    <T>(...refs: (ForwardedRef<T> | undefined)[]): RefCallback<T> =>
    (element) => {
        refs.forEach((ref) => {
            if (typeof ref === "function") ref(element);
            else if (ref) ref.current = element;
        });
    };
